import React from 'react';
import { Link } from '@inertiajs/react';
import MainLayout from './layouts/MainLayout';
import CommunityCard from '@/components/CommunityCard';
import Footer from '@/components/Footer';
import SearchFilters from '@/components/SearchFilters';

export default function Search({ facilities = [], filters = {}, pagy, filter_options = {} }) {
  return (
    <MainLayout>
      {/* Search Filters Component */}
      <SearchFilters filters={filters} totalResults={facilities.length} pagy={pagy} filter_options={filter_options} />
      
      {/* Results Section */}
      <div className="bg-gray-50 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {facilities.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {facilities.map(facility => (
                <Link 
                  key={facility.id} 
                  href={facility.slug ? `/facilities/${facility.slug}` : `/facilities/${facility.id}`}
                  className="transform transition-all hover:-translate-y-1"
                >
                  <CommunityCard community={facility} />
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-12 bg-white rounded-lg shadow-sm">
              <h3 className="text-lg font-medium text-gray-900">No communities found</h3>
              <p className="mt-2 text-sm text-gray-500">Try adjusting your search criteria</p>
            </div>
          )}
        </div>
      </div>
      
      <Footer />
    </MainLayout>
  );
}
